import { BehaviorParameters } from 'rangeConfig/@types';

const replaceSelectedTopPanel = ({ coreApi, props }: BehaviorParameters) => {
  const top = coreApi.entities.findSelectedEntity();
  if (!top) {
    return;
  }

  const replacePlacementResult = coreApi.products.removeAndAdd(top.id, props.coreProductId);
  if (replacePlacementResult?.valid && replacePlacementResult.placedEntity) {
    coreApi.entities.select(replacePlacementResult.placedEntity);
  }
};

export default replaceSelectedTopPanel;
